const SESSION_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
const BROWSER_LOGIN_STORAGE_KEY = 'autosquare_geofusion_browser_login'

export function safeReturnPath(value) {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && !/[\\\x00-\x20]/.test(value) && !/^\/login(?:-complete)?(?:[/?#]|$)/.test(value)
    ? value
    : '/'
}

export function buildBrowserSuccessUrl(location) {
  return new URL('/login-complete', location.origin).toString()
}

export function saveBrowserLoginState(storage, session, returnPath = '/') {
  const state = {
    session_id: session.session_id,
    poll_interval_seconds: Number(session.poll_interval_seconds) || 2,
    return_path: safeReturnPath(returnPath)
  }
  storage.setItem(BROWSER_LOGIN_STORAGE_KEY, JSON.stringify(state))
  return state
}

export function clearBrowserLoginState(storage) {
  storage.removeItem(BROWSER_LOGIN_STORAGE_KEY)
}

export function loadBrowserLoginState(storage) {
  try {
    const state = JSON.parse(storage.getItem(BROWSER_LOGIN_STORAGE_KEY) || 'null')
    if (
      !state ||
      !SESSION_ID_PATTERN.test(state.session_id) ||
      !state.session_id
    ) {
      clearBrowserLoginState(storage)
      return null
    }
    return {
      session_id: state.session_id,
      poll_interval_seconds: Number(state.poll_interval_seconds) || 2,
      return_path: safeReturnPath(state.return_path || '/')
    }
  } catch {
    clearBrowserLoginState(storage)
    return null
  }
}

export async function pollBrowserSession({ api, session, delay = null }) {
  const wait = delay || ((milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds)))
  const interval = Math.max(Number(session.poll_interval_seconds) || 2, 1) * 1000
  let consecutiveFailures = 0
  while (true) {
    try {
      const response = await api.get(`/auth/browser-session/${session.session_id}/`)
      if (response.data.status === 'completed') return response.data
      consecutiveFailures = 0
    } catch (error) {
      if (error.response?.status === 410 || error.response?.status === 404) {
        const expiredError = new Error('登录会话已失效，请重新登录。')
        expiredError.sessionExpired = true
        throw expiredError
      }
      const status = error.response?.status
      const retryable = !status || status === 408 || status === 429 || status >= 500
      if (retryable && consecutiveFailures < 3) {
        consecutiveFailures += 1
        await wait(interval)
        continue
      }
      throw new Error('无法确认登录结果，请检查账号中心服务。')
    }
    await wait(interval)
  }
}
